package com.wintermar.inspection.feature.presentation.inspection.answer

import com.wintermar.inspection.feature.domain.model.answer.AnswerModel
import com.wintermar.inspection.graphql.type.InspectionAnswerType

//actual suspend fun processAnswerPlatform(
//    answer: AnswerModel,
//    answerType: InspectionAnswerType,
//    includeUploadFile: Boolean,
//    onSaveAnswer: suspend (AnswerModel) -> Unit,
//    onSubmitAnswer: suspend (AnswerModel, InspectionAnswerType, Boolean, Boolean) -> Unit
//) {
//    onSubmitAnswer(answer, answerType, includeUploadFile, false)
//}

actual suspend fun processUpdateProgressPlatform(
    onUpdate: suspend () -> Unit,
    onGoToLanding: suspend () -> Unit
) {
    onGoToLanding()
}
